import { MenuItemProps, useTranslations } from "@bsm/component";

export const useLangMenuItems = (): Array<MenuItemProps> => {
    const [FRENCH, ENGLISH] = useTranslations(i18n);
    return [
        {
            ke: "fr",
            label: FRENCH,
            startIcon: <img src={'/assets/logo/FR.png'} className="h-4" alt="FR" />
        },
        {
            ke: "en",
            label: ENGLISH,
            startIcon: <img src={'/assets/logo/GB.png'} className="h-4" alt="EN" />
        },
    ];
};

const i18n = ["Generic.de.FR", "Generic.de.EN"];
